import React from 'react';
import { useNavigate } from 'react-router-dom';

import { userService } from '../../services/adminService';
import { DepartmentSummary } from '../../types/domain';
import { withAdminDepartment } from '../../utils/adminViewMode';

interface Props {
  workspace: 'logistics' | 'accountable';
}

const WORKSPACE_PATH: Record<Props['workspace'], string> = {
  logistics: '/logistics-dashboard',
  accountable: '/accountable-dashboard',
};

const WORKSPACE_LABEL: Record<Props['workspace'], string> = {
  logistics: 'Logistics',
  accountable: 'Accountable',
};

const AdminDepartmentWorkspacePicker: React.FC<Props> = ({ workspace }) => {
  const navigate = useNavigate();
  const [departments, setDepartments] = React.useState<DepartmentSummary[]>([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let mounted = true;
    userService.getDepartments()
      .then((items) => {
        if (mounted) setDepartments(items.filter((department) => department.is_active !== false));
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, []);

  const enterWorkspace = () => {
    if (!selectedDepartment) return;
    navigate(withAdminDepartment(WORKSPACE_PATH[workspace], Number(selectedDepartment)));
  };

  return (
    <div className="workspace-placeholder">
      <h1>Select Department</h1>
      <p>Choose a department before entering {WORKSPACE_LABEL[workspace]} Administrator View Mode.</p>
      {loading ? (
        <p>Loading departments...</p>
      ) : (
        <>
          <select value={selectedDepartment} onChange={(event) => setSelectedDepartment(event.target.value)}>
            <option value="">Select department</option>
            {departments.map((department) => (
              <option key={department.id} value={department.id}>
                {department.name} ({department.code})
              </option>
            ))}
          </select>
          <button className="btn btn-primary" type="button" disabled={!selectedDepartment} onClick={enterWorkspace}>
            Enter Workspace
          </button>
        </>
      )}
    </div>
  );
};

export default AdminDepartmentWorkspacePicker;
